module.exports = __webpack_public_path__ + "static/brief_thank_you-98464f93a4e701a53d6fc993db524028.png";